function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.62147 5.81375C7.55063 5.6725 7.40647 5.58334 7.24856 5.58334H6.41522V1.41666C6.41522 1.18666 6.22897 1 5.99856 1C5.76815 1 5.5819 1.18666 5.5819 1.41666V5.58332H4.74856C4.59065 5.58332 4.44647 5.67248 4.37565 5.81373C4.30565 5.95498 4.32065 6.12373 4.41524 6.24998L5.66524 7.91664C5.67065 7.92373 5.67899 7.92623 5.68483 7.93289C5.71233 7.96539 5.74483 7.99039 5.78108 8.0133C5.79608 8.02246 5.80774 8.03455 5.82399 8.04205C5.87733 8.06705 5.93565 8.0833 5.99858 8.0833C6.06151 8.0833 6.11983 8.06705 6.17358 8.04205C6.18942 8.03455 6.20149 8.02246 6.21608 8.0133C6.25233 7.99039 6.28483 7.96539 6.31233 7.93289C6.31774 7.92623 6.32649 7.92373 6.33192 7.91664L7.58192 6.24998C7.6769 6.12375 7.6919 5.955 7.62147 5.81375Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5833 7.25C10.3529 7.25 10.1667 7.43666 10.1667 7.66666V8.91666C10.1667 9.60582 9.60584 10.1667 8.91668 10.1667H3.08334C2.39418 10.1667 1.83334 9.60582 1.83334 8.91666V7.66666C1.83334 7.43666 1.64709 7.25 1.41668 7.25C1.18625 7.25 1 7.43666 1 7.66666V8.91666C1 10.0654 1.93459 11 3.08334 11H8.91668C10.0654 11 11 10.0654 11 8.91666V7.66666C11 7.43666 10.8138 7.25 10.5833 7.25Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.4
});

function SvgUploadicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/upload.icon.792b6dbe.svg";
export { ForwardRef as ReactComponent };